import React, { useState } from "react";
import { InputComponent } from "../../../core/Forms";
import { convertImageToBase64 } from "../../../../utils/convertToBase64";
import EmptyLogo from "../../../../assets/icons/emptyLogo";
import PhoneInputComponent from "../../../common/PhoneInputComponent";
import NewEditIcon from "../../../../assets/icons/NewEditIcon";
import { useTranslation } from "react-i18next";

interface ViewProps {
  formData: {
    firstName: string;
    lastName: string;
    businessName: string;
    industry: string;
    email?: string;
    phone: string;
    address: string;
    state: string;
    city: string;
    businessSize: string;
    code: string;
    brandColor: string;
    logoBase64: string;
  };
}

export const View: React.FC<ViewProps> = ({ formData }) => {
  const { t } = useTranslation("settings");
  return (
    <>
      <div className="border-[0.5px] border-[#A4A4A4] py-3 rounded-[8px]">
        <div className="py-3 mt-[-10px] font-medium text-gray-600  border-b-[0.5px] rounded-t-[8px] px-4 bg-gray-50  border-[#A4A4A4]">
          Business Details
        </div>

        <div className="mt-4 flex flex-col gap-[2em] w-full  md:justify-start">
          <div className="space-y-2 w-full">
            <div className="flex  justify-between items-center px-4 pb-3 py-3  border-b ">
              <p className="text-gray-600">Business Name</p>
              <p className="font-medium">{formData.businessName}</p>
            </div>
            <div className="flex  justify-between items-center px-4 pb-3 py-3  border-b leading-[16.8px] text-[#101010]">
              <p className="text-gray-600">Business Size</p>
              <p className="font-medium">{formData.businessSize || "NA"}</p>
            </div>
            <div className="flex  justify-between items-center px-4 pb-3 py-3  border-b leading-[16.8px] text-[#101010]">
              <p className="text-gray-600">Business {t("Settings.category")}</p>
              <p className="font-medium mt-2">{formData.industry || "NA"}</p>
            </div>
            <div className="flex justify-between items-center px-4 pb-3 py-3    border-b leading-[16.8px] text-[#101010]">
              <p className="text-gray-600">CAC code</p>
              <p className="font-medium mt-2">{formData.code || "N/A"}</p>
            </div>
            {/* <div className="text-[14px] leading-[16.8px] text-[#101010]">
              <p>{t("Settings.phonenumber")}</p>
              <p className="font-medium mt-2">{formData.phone}</p>
            </div> */}
            <div className="flex  justify-between items-center px-4 pb-3 py-3   border-b leading-[16.8px] text-[#101010]">
              <p>{t("Settings.address")}</p>
              <p className="font-medium mt-2">{formData.address}</p>
            </div>
            <div className="flex justify-between items-center px-4 pb-3 py-3   border-b leading-[16.8px] text-[#101010]">
              <p className="text-gray-600">{t("Settings.city")} </p>
              <p className="font-medium ">{formData.city || "N/A"}</p>
            </div>

            <div className="flex justify-between items-center px-4 pb-4 py-3    border-b  leading-[16.8px] text-[#101010]">
              <p className="text-gray-600">{t("Settings.state")} </p>
              <p className="font-medium ">{formData.state || "N/A"}</p>
            </div>
            <div className="flex justify-between items-center px-4 border-b leading-[16.8px] text-[#101010]">
              <p className="text-gray-600">Brand Logo </p>

              {formData.logoBase64 ? (
                <div className="h-14 w-36 flex items-center justify-end">
                  <img
                    src={formData.logoBase64}
                    alt="Logo"
                    className="object-center"
                  />
                </div>
              ) : (
                <p className="font-medium ">No brand logo</p>
              )}
            </div>
            <div className="flex justify-between items-center px-4 pt-1   leading-[16.8px] text-[#101010]">
              <p className="text-gray-600">Brand Color</p>
              {formData.brandColor ? (
                <div
                  style={{
                    backgroundColor: formData.brandColor || "#044E97",
                  }}
                  className={`h-10 w-10 rounded-full mr-3 ${
                    formData.brandColor
                      ? `bg-[${formData.brandColor}]`
                      : "bg-[#044E97]"
                  }`}
                ></div>
              ) : (
                <p className="font-medium ">No brand color</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
